import React from 'react';
import { PlaysGridRowManager } from 'services/PlaysGridRowManager';
import { observer } from 'mobx-react-lite';
import { ISession } from 'interfaces/session/ISession';
import { GridView } from '../GridView/GridView';
import { PitcherViewWrapper } from './styles/PitcherViewStyles';
import { pitcherToCombinedBoxScoreData } from '../helpers/playerMappingHelper';

interface IProps {
  rowManager: PlaysGridRowManager;
  session: ISession;
  isAwayTeam: boolean;
  isLoading: boolean;
}
export const PitcherView: React.FC<IProps> = observer((props) => {
  const { rowManager, isAwayTeam, isLoading } = props;
  const { trackmanBoxScore, secondSourceBoxScore } = rowManager.boxScoreManager;

  const awayTeamData = trackmanBoxScore.awayTeam.pitching.map((player) =>
    pitcherToCombinedBoxScoreData(player, secondSourceBoxScore.awayTeam.pitching)
  );
  const homeTeamData = trackmanBoxScore.homeTeam.pitching.map((player) =>
    pitcherToCombinedBoxScoreData(player, secondSourceBoxScore.homeTeam.pitching)
  );

  const onPitcherSelected = (isChecked: boolean, pitcherId: string) => {
    isChecked ? rowManager.boxScoreManager.selectPitcher(pitcherId) : rowManager.boxScoreManager.deselectPitcher(pitcherId);
  };

  return (
    <PitcherViewWrapper>
      <GridView
        data={isAwayTeam ? awayTeamData : homeTeamData}
        isPitcherView
        selectedIds={rowManager.boxScoreManager.selectedPitcherIds}
        onPlayerSelectionChange={onPitcherSelected}
        discrepancies={
          isAwayTeam ? rowManager.boxScoreManager.awayPitcherDiscrepancies : rowManager.boxScoreManager.homePitcherDiscrepancies
        }
        isLoading={isLoading}
      />
    </PitcherViewWrapper>
  );
});
